import { Link } from 'react-router-dom';
import { appRoutes } from '../../../app-routes';
import { useVoiceTemplateUsage } from '../useTemplateComponents';
import { COMPONENT_PAGE_COPY } from './component-page-copy';
import { FormCard } from './FormCard';
import styles from './UsedInCard.module.css';

interface UsedInCardProps {
  componentId?: string;
}

/** Where the component is used. Read-only: a component is added to a template from the template. */
export const UsedInCard = ({ componentId }: UsedInCardProps) => {
  const { voiceTemplateUsesComponent } = useVoiceTemplateUsage(componentId);

  return (
    <FormCard title={COMPONENT_PAGE_COPY.usedInHeading}>
      {voiceTemplateUsesComponent ? (
        <Link className={styles.template} to={appRoutes.AGENT_VOICE_TEMPLATE}>
          Voice template
        </Link>
      ) : (
        <p className={styles.none}>{COMPONENT_PAGE_COPY.usedInNone}</p>
      )}
    </FormCard>
  );
};
